import React from 'react';

const Logo = props => {
  return (
    <img alt="Logo" src="/logo.png" style={{ width: '40px' }} {...props} />
  );
};

export default Logo;
